import React, { useState } from "react";
import { Asterisk } from "@phosphor-icons/react";

const ITEMS = [
    "Sites web",
    "Photographie",
    "Production vidéo",
    "Identité de marque",
    "Marketing visuel",
    "Direction artistique",
];

export default function Marquee() {
    const [hover, setHover] = useState(false);

    return (
        <section
            data-testid="marquee-strip"
            aria-hidden
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            className="border-y border-scd bg-elev overflow-hidden cursor-default"
        >
            <div
                className="flex whitespace-nowrap py-6"
                style={{
                    animation: `marquee ${hover ? "12s" : "40s"} linear infinite`,
                }}
            >
                {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((item, i) => (
                    <div
                        key={i}
                        className="flex items-center gap-6 px-8 font-display text-3xl md:text-4xl text-cream"
                    >
                        <Asterisk
                            size={28}
                            weight="bold"
                            className={`text-yellow transition-transform duration-300 ${hover ? "rotate-180 scale-125" : ""}`}
                        />
                        <span>{item}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
